import React from 'react';
import { Duration } from '@common/tokens';
import { Select as AntSelect } from 'antd';
import type { SelectProps } from 'antd';
import clsx from 'clsx';

// NOTE: antd 4 hides the Select arrow in multiple/tags mode unless `showArrow`
// is set, so this wrapper opts it back in to match the single-value Select.
export function Select<ValueType = unknown>({
  mode,
  className,
  showArrow,
  ...props
}: Omit<SelectProps<ValueType>, 'style'>) {
  const isMultiple = mode === 'multiple' || mode === 'tags';
  const mergedShowArrow = showArrow ?? (isMultiple || undefined);

  return (
    <>
      <AntSelect<ValueType>
        {...props}
        mode={mode}
        style={{ width: '100%' }}
        showArrow={mergedShowArrow}
        className={clsx('wk-select', className)}
      />
      <style jsx>{`
        :global(.wk-select.ant-select-multiple .ant-select-arrow) {
          transition: opacity ${Duration.fast} ease;
        }
        /*
         * The clear button only renders when a value is present and reuses the
         * arrow's slot, so fade the chevron out on hover to let it through.
         */
        :global(
          .wk-select.ant-select-multiple.ant-select-allow-clear:hover:has(
              .ant-select-clear
            )
            .ant-select-arrow
        ) {
          opacity: 0;
        }
      `}</style>
    </>
  );
}

Select.Option = AntSelect.Option;
Select.OptGroup = AntSelect.OptGroup;
